/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Legend_DeniedInputs */



/**
* | output |
* | --- |
* | "Explicitly denied (floor)" |
*
* @param {Rights_Legend_DeniedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_legend_denied = /** @type {((inputs?: Rights_Legend_DeniedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Legend_DeniedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Explizit verweigert (Sperre)")
	return /** @type {LocalizedString} */ ("Explicitly denied (floor)")
});